import { cloneElement, useCallback } from 'react'
import { updateStateProps } from '../../actions'
import { hooks } from '@sparky/framework'

import type { VFC } from 'react'
import type { ScreenComponentProps } from '../../renderer'
import { ACCORDION_COMPLETE_EVENT_KEY } from '../../constants'
import type { ActivationStep } from '../../store'

const { useGlobalEventListener } = hooks
const UDefaultActivationScreen: VFC<ScreenComponentProps> = (props) => {
  const { state, children } = props
  const { activationSteps } = state

  /**
   * listen to the accordion complete event and update activationSteps accordingly
   */
  useGlobalEventListener(ACCORDION_COMPLETE_EVENT_KEY, (completeKey: string) => {
    // console.log(`${completeKey} triggered handler`)
    const completedComponent = activationSteps[completeKey]
    if (completedComponent.isDone) {
      // component fired event already done, skip
      return
    }
    const readyStepKey = findItemsWithFulfilledDependencies({
      ...activationSteps,
      [completeKey]: {
        ...completedComponent,
        isDone: true,
      },
    })
    // if found next component ready
    if (readyStepKey) {
      const nextComponent = activationSteps[readyStepKey]
      const newSteps = {
        ...activationSteps,
        [completeKey]: {
          ...completedComponent,
          isDone: true,
        },
        [readyStepKey]: {
          ...nextComponent,
          isAccordionEnabled: true
        }
      }
      // console.log({ newSteps })
      updateStateProps({
        activationSteps: newSteps
      })
    }
  })

  const renderChildInformation = useCallback((children: any) => {
    return children?.props?.children.map((child: any) => {
      return cloneElement(child, { ...child.props })
    })
  }, [])
  return <div className='cm-px-20 cm-w-[100vw]'>
    <div className='cm-flex cm-mt-28 cm-flex-1 cm-flex-col cm-px-20 cm-items-center'>
      {renderChildInformation(children)}
    </div>
  </div>
}

export default UDefaultActivationScreen

function findItemsWithFulfilledDependencies(data: { [key: string]: ActivationStep }): string {
  const fulfilledItems: string[] = []
  const isDependenciesFulfilled = (dependencies: number[]): boolean => {
    for (const dependency of dependencies) {
      const dependentItem = Object.values(data).find(
        (item) => item.index === dependency
      )

      if (!dependentItem || !dependentItem.isDone) {
        return false
      }
    }
    return true
  }

  for (const item of Object.values(data)) {
    if (item.index !== 0 && !item.isDone && isDependenciesFulfilled(item.dependencies)) {
      fulfilledItems.push(item.key)
    }
  }
  // right now only 1 can be found, so just return the first element
  return fulfilledItems[0]
}
